export const FETCH_ALL = `artists/FETCH_ALL`
export const FETCH_ALL_FULFILLED = `artists/FETCH_ALL_FULFILLED`
export const FETCH_ALL_FAILED = `artists/FETCH_ALL_FULFILLED`